// mobile number regex
export const mobileRegex = /^(0|91)?[6-9][0-9]{9}$/;

// email id regex
export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
